export default __webpack_public_path__ + "static/media/octavia.c2d30619.png";